var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSuccessful = function SvgSuccessful(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF5C32",
    strokeWidth: 3,
    d: "M2.521 42.15S.624 21.497 14.758 10.066c16.595-13.42 48.177-4.493 41.018 26.385C48.618 67.33 8.841 58.754 12.45 35.375"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF5C32",
    strokeWidth: 3,
    d: "m22.618 31.325 7.5 7.059C32.765 32.943 34 26 42 22.5"
  })));
};
export default SvgSuccessful;